import { getQueryObject } from './getQueryObject';
import { getInit } from './getInit';
import { setQuery } from './setQuery';

export const queryUtil = {
  getInit,
  getQueryObject,
  setQuery
};
